module.exports = __webpack_public_path__ + "img/feedback_game_over_loop_dark.e283098b.gif";